module.exports = __webpack_public_path__ + "static/media/edge_exploded_SmallStellatedDodecahedron.866d0887.gif";